export const principalColor = "rgb(8, 60, 60)";
export const lightPricipalColor = "#008080";
export const darkPrincipalColor = "rgb(9, 91, 106)";
export const blackColor = "#131516";
export const lessBlackColor = "#212529";
export const textColor = "#adb5bd";
export const textLightColor = "#e9ecef";
export const textWhiteColor = "#fff";
export const blueLight = "rgb(101, 223, 243)";
export const colorContactAndButtons = "rgb(13, 122, 138)";
export const inputBackground = "rgb(7, 58, 63)";
export const boxShadow = "0 1px 2px rgba(0, 0, 0, 0.07)";
export const boxShadowBtn = "0 0.5rem 1rem rgba(0, 0, 0, 0, 0.2)";
export const btnContactHover = "#0c8599";
export const blueTextColor = "#0b7285";
